module.exports = __webpack_public_path__ + "img/img_ghost_14@3x.3786fd31.png";